"use strict";
//@ts-check
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dtype_least_ancestor = exports.dtype_is_float = exports.dtype_is_boolean = exports.dtype_is_integer = exports.dtype_lt = exports.dtype_leq = exports.dtype_eq = exports.new_buffer = exports.dtypes = void 0;
// Mozilla docs:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray
// This is a mess:
// https://stackoverflow.com/questions/65129070/
// https://stackoverflow.com/questions/49242232/
// https://stackoverflow.com/questions/69783310/
exports.dtypes = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array]; //, BigInt64Array, BigUint64Array]
function new_buffer(size_or_array, dtype) {
    //@ts-ignore
    return dtype ? new dtype(size_or_array) : new Float64Array(size_or_array);
}
exports.new_buffer = new_buffer;
// dtype comparison (hierarchical)
function dtype_eq(A, B) {
    return A === B;
}
exports.dtype_eq = dtype_eq;
function dtype_leq(A, B) {
    return hierarchy_leq[A.name + B.name] || false;
}
exports.dtype_leq = dtype_leq;
function dtype_lt(A, B) {
    return hierarchy_lt[A.name + B.name] || false;
}
exports.dtype_lt = dtype_lt;
function dtype_is_integer(A) {
    return A === Uint32Array || A === Uint8Array || A === Int8Array || A === Uint8ClampedArray || A === Int16Array || A === Uint16Array || A === Int32Array; // || A === BigInt64Array || A === BigUint64Array;
}
exports.dtype_is_integer = dtype_is_integer;
function dtype_is_boolean(A) {
    return A === Uint8Array;
}
exports.dtype_is_boolean = dtype_is_boolean;
function dtype_is_float(A) {
    return A === Float32Array || A === Float64Array;
}
exports.dtype_is_float = dtype_is_float;
function dtype_least_ancestor() {
    var dtypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        dtypes[_i] = arguments[_i];
    }
    return dtypes.reduce(function (a, b) { return hierarchy_max[a.name + b.name]; }, Float64Array);
}
exports.dtype_least_ancestor = dtype_least_ancestor;
var _a = (function () {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var descendants = {
        Uint8Array: [],
        Int8Array: [],
        Uint8ClampedArray: [],
        Int16Array: ['Int8Array', 'Uint8Array', 'Uint8ClampedArray'],
        Uint16Array: ['Int8Array', 'Uint8Array', 'Uint8ClampedArray'],
        Int32Array: ['Int16Array', 'Uint16Array', 'Int8Array', 'Uint8Array', 'Uint8ClampedArray'],
        Uint32Array: ['Int16Array', 'Uint16Array', 'Int8Array', 'Uint8Array', 'Uint8ClampedArray'],
        BigInt64Array: ['Int32Array', 'Uint32Array', 'Int16Array', 'Uint16Array', 'Int8Array', 'Uint8Array', 'Uint8ClampedArray'],
        BigUint64Array: ['Int32Array', 'Uint32Array', 'Int16Array', 'Uint16Array', 'Int8Array', 'Uint8Array', 'Uint8ClampedArray'],
        Float32Array: ['Int32Array', 'Uint32Array', 'Int16Array', 'Uint16Array', 'Int8Array', 'Uint8Array', 'Uint8ClampedArray', 'BigUint32Array', 'BigInt32Array'],
        Float64Array: ['Float32Array', 'Int32Array', 'Uint32Array', 'Int16Array', 'Uint16Array', 'Int8Array', 'Uint8Array', 'Uint8ClampedArray', 'BigUint32Array', 'BigInt32Array', 'BigUint64Array', 'BigInt64Array'],
    };
    var ltPairs = [];
    var leqPairs = [];
    var _loop_1 = function (key, value) {
        leqPairs.push(key + key);
        leqPairs.push.apply(leqPairs, __spreadArray([], __read(value.map(function (v) { return key + v; })), false));
        ltPairs.push.apply(ltPairs, __spreadArray([], __read(value.map(function (v) { return key + v; })), false));
    };
    try {
        for (var _e = __values(Object.entries(descendants)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var _g = __read(_f.value, 2), key = _g[0], value = _g[1];
            _loop_1(key, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var hierarchy_leq = Object.fromEntries(leqPairs.map(function (pair) { return [pair, true]; }));
    var hierarchy_lt = Object.fromEntries(ltPairs.map(function (pair) { return [pair, false]; }));
    var hierarchy_max = {};
    try {
        for (var dtypes_1 = __values(exports.dtypes), dtypes_1_1 = dtypes_1.next(); !dtypes_1_1.done; dtypes_1_1 = dtypes_1.next()) {
            var A = dtypes_1_1.value;
            try {
                for (var dtypes_2 = (e_3 = void 0, __values(exports.dtypes)), dtypes_2_1 = dtypes_2.next(); !dtypes_2_1.done; dtypes_2_1 = dtypes_2.next()) {
                    var B = dtypes_2_1.value;
                    var lca = Float64Array;
                    try {
                        for (var dtypes_3 = (e_4 = void 0, __values(exports.dtypes)), dtypes_3_1 = dtypes_3.next(); !dtypes_3_1.done; dtypes_3_1 = dtypes_3.next()) {
                            var C = dtypes_3_1.value;
                            if (leqPairs[A.name + C.name] && leqPairs[B.name + C.name] && leqPairs[C.name + lca.name]) {
                                lca = C;
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (dtypes_3_1 && !dtypes_3_1.done && (_d = dtypes_3.return)) _d.call(dtypes_3);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    hierarchy_max[A.name + B.name] = lca;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (dtypes_2_1 && !dtypes_2_1.done && (_c = dtypes_2.return)) _c.call(dtypes_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (dtypes_1_1 && !dtypes_1_1.done && (_b = dtypes_1.return)) _b.call(dtypes_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return { hierarchy_leq: hierarchy_leq, hierarchy_lt: hierarchy_lt, hierarchy_max: hierarchy_max };
})(), hierarchy_leq = _a.hierarchy_leq, hierarchy_lt = _a.hierarchy_lt, hierarchy_max = _a.hierarchy_max;
// BigInt64Array |
// BigUint64Array;
